export default __webpack_public_path__ + "static/media/Rubik-Regular.cdf97d58.ttf";